<template>
    <div class="page-home">
        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="12" :xl="12" class="m-b-10 m-b-sm-20">
                <el-card v-if="$mobile()" shadow="never" class="hello-user">
                    <h2>Последнее сообщение: <span v-html="lastMessage"></span></h2>
                </el-card>
                <el-card v-else shadow="never" class="el-card--with-table">
                    <card
                          margin="0px"
                          :icon="lastEvent.Level"
                          :title="devicesTable.find(x => x.ID === lastEvent.DeviceId) ? devicesTable.find(x => x.ID === lastEvent.DeviceId).Name : 'Устройство №' + lastEvent.DeviceId"
                          :date="lastEvent.Time"
                          :description="lastEvent.Name + ': ' + lastEvent.Value"
                    >
                    </card>
                </el-card>
            </el-col>
            <el-col :sm="24" :md="8" :lg="4" :xl="4" class="m-b-10 m-b-sm-20">
                <el-card shadow="never">
                    <h2>Тревоги: <span class="color-danger">{{cnt.alarms}}</span></h2>
                </el-card>
            </el-col>
            <el-col :sm="24" :md="8" :lg="4" :xl="4" class="m-b-10 m-b-sm-20">
                <el-card shadow="never">
                    <h2>Зоны: <span class="color-success">{{cnt.zones}}</span></h2>
                </el-card>
            </el-col>
            <el-col :sm="24" :md="8" :lg="4" :xl="4" class="m-b-10 m-b-sm-20">
                <el-card shadow="never">
                    <h2>Устройства: <span class="color-success">{{cnt.devices}}</span></h2>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <el-card shadow="never" class="m-b-20 el-card--with-table" v-if="devicesTable">
                    <div slot="header" class="clearfix">
                        <el-row :gutter="20">
                            <el-col :sm="24" :md="6" :lg="6" :xl="6">
                                <h2>Устройства</h2>
                            </el-col>
                            <el-col :sm="24" :md="6" :lg="6" :xl="6" class="m-b-10 m-b-lg-0">
                                <el-input placeholder="Искать устройство"
                                          style="margin-top: -8px;"
                                          v-model="form.Search"
                                          @change="selectSearch"
                                          clearable>
                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                </el-input>
                            </el-col>
                            <el-col :sm="24" :md="6" :lg="6" :xl="6" class="m-b-10 m-b-lg-0" v-if="zonesDict">
                                <el-select @change="selectStatus" style="margin-top: -8px;" v-model="form.StatusID" placeholder="Статус" class="w-100" multiple>
                                    <el-option
                                            v-for="item in $statuses"
                                            :key="item.status"
                                            :label="item.text"
                                            :value="item.status">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :sm="24" :md="6" :lg="6" :xl="6" v-if="zonesDict">
                                <el-select @change="selectZone" style="margin-top: -8px;" v-model="form.ZoneID" placeholder="Зона" class="w-100" default-first-option clearable>
                                    <el-option
                                            v-for="item in zonesDict"
                                            :key="item.ID"
                                            :label="item.Name"
                                            :value="item.ID">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>
                    <el-table v-loading="loadingDevices" :data="devicesTableFiltered">
                        <el-table-column prop="ID" label="Номер" width="85px">
                            <template slot-scope="scope">
                                {{scope.row.ID}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="Level" label="" width="55px">
                            <template slot-scope="scope">
                                <icon type="status" :level="scope.row.Level"></icon>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Name" label="Название">
                            <template slot-scope="scope">
                                <div class="font-weight-bold">
                                    <a href="#" @click.prevent="showDetails(scope.row.ID)" class="color-black">
                                        {{ scope.row.Name }}
                                    </a>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>

            </el-col>
            <el-col :sm="24" :md="24" :lg="12" :xl="12">
                <el-card shadow="never" class="m-b-20 el-card--with-table">
                    <div slot="header" class="clearfix">
                        <h2>Тревоги</h2>
                    </div>

                    <div v-if="!$mobile()">
                        <div v-for="(item, key) in alarmsTable" :key="key">
                            <card
                                v-loading="loading"
                                :icon="item.Level"
                                :title="devicesTable.find(x => x.ID === item.DeviceId).Name"
                                :date="item.Time"
                                :description="item.Name + ': ' + item.Value"
                            >
                            </card>
                        </div>
                    </div>
                    <div v-else>
                        <el-table v-loading="loading" :data="alarmsTable" :default-sort="{prop: 'Time', order: 'descending'}">

                            <el-table-column prop="Level" label="" width="60px">
                                <template slot-scope="scope">
                                    <icon :level="scope.row.Level"></icon>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Time" label="Время">
                                <template slot-scope="scope">
                                    <table-date :date="scope.row.Time"/>
                                </template>
                            </el-table-column>
                            <el-table-column prop="DeviceId" label="Устройство">
                                <template slot-scope="scope">
                                    <div class="font-weight-bold" v-if="devicesTable.find(x => x.ID === scope.row.DeviceId)">
                                        {{ devicesTable.find(x => x.ID === scope.row.DeviceId).Name }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Name" label="Описание">
                                <template slot-scope="scope">
                                    <div>
                                        {{ scope.row.Name }}: {{ scope.row.Value }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import {mapMutations, mapGetters} from 'vuex'

    export default {
        data () {
            return {
                loading: false,
                loadingDevices: false,
                devicesTable: [],
                devicesTableFiltered: [],
                alarmsTable: [],
                devicesTypes: [],
                form: {
                    ZoneID: '',
                    StatusID: '',
                    Search: ''
                },
                zonesDict: [],
                cnt: {
                    zones: 0,
                    alarms: 0,
                    devices: 0
                },
                statuses: [
                    { id: 4, name: 'В норме' },
                    { id: 1, name: 'Не в сети' },
                    { id: 2, name: 'С предупреждениями' },
                    { id: 3, name: 'С тревогами' }
                ],
                children: [],
                lastMessage: '',
                lastEvent: {}
            }
        },
        computed: {
            ...mapGetters(['user', 'initCondition']),
        },
        methods: {
            ...mapMutations(['setCondition']),
            getData () {

            },
            selectSearch () {
                this.setCondition({model: this.form})
                this.getFilteredDevices()
            },
            selectZone () {
                this.setCondition({model: this.form})
                this.getFilteredDevices()
            },
            selectStatus () {
                console.log(this.form.StatusID)
                this.setCondition({model: this.form})
                this.getFilteredDevices()
            },
            getFilteredDevices () {
                this.loadingDevices = true

                this.children = []
                let arr = []

                let zoneIDTree = null
                if (this.form.ZoneID) {
                    if (this.zonesDict.find(x => x.ID === this.form.ZoneID)) {
                        zoneIDTree = this.zonesDict.find(x => x.ID === this.form.ZoneID).TreeItemIdAsString
                    }
                }

                this.devicesTable.filter(row => {
                    row.Level = row.ImageType
                    return row
                })


                this.devicesTable.filter(row => {
                    if (row.ParentTreeItemIdAsString === zoneIDTree || !this.form.ZoneID) {

                        row.children = []
                        this.devicesTable.filter(child => {
                            if (child.ParentTreeItemIdAsString === row.TreeItemIdAsString) {

                                let isStatus = false
                                if (this.form.StatusID.indexOf(child.ImageType) !== -1 || (!this.form.StatusID || this.form.StatusID.length === 0)) {
                                    isStatus = true
                                }
                                // назначаем тревоги для родителей, если у потомков они есть
                                if ((child.ImageType != row.ImageType || (!row.ImageType && child.ImageType)) && child.ImageType !== 'Normal') {
                                    row.Level = child.Level
                                }

                                // добавляем потомков если их статус совпал
                                if (isStatus) {
                                    row.children.push(child)
                                    this.children.push(child.ID)
                                }
                            }
                        })

                        if (!row.Level) row.Level = 'Normal'

                        // поиск по статусу и имени устройства
                        if (
                                (this.form.StatusID.indexOf(row.Level) !== -1 || (!this.form.StatusID || this.form.StatusID.length === 0))
                                && (row.Name.indexOf(this.form.Search) !== -1 || !this.form.Search)
                        ) {
                            arr.push(row)
                        }
                    }
                })

                this.devicesTableFiltered = arr

                // this.devicesTableFiltered = arr.filter(device => {
                //     if (this.children.indexOf(device.ID) === -1) {
                //         return device
                //     }
                // })
                this.loadingDevices = false
            },
            getDevices () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Device"
                }, this.form)

                this.$api.Main.getDevices(request).then(response => {
                    this.devicesTable = response.Items
                    this.loading = false
                    this.cnt.devices = response.Total

                    this.getAlarms()
                })
            },
            getAlarms () {
                let request = Object.assign({
                    Name: "GetActualAlarms"
                }, this.form)

                this.$api.Main.getAlarms(request).then(response => {
                    this.alarmsTable = response.Alarms.filter(x => x.Level > 1)
                    this.cnt.alarms = 0

                    // последнее сообщение
                    this.lastEvent = this.alarmsTable[0]
                    let last = this.alarmsTable[0]
                    let icon = this.$alarms.find(x => x.id === last.Level)
                    let device = "Устройство ID=" + last.DeviceId
                    if (this.devicesTable.find(x => x.ID === last.DeviceId)) {
                        device = this.devicesTable.find(x => x.ID === last.DeviceId).Name
                    }
                    this.lastMessage = "<span class='" + icon.color + "'>" + device + ": " + last.Name + " " + last.Value + "</span>"
                    // последнее сообщение


                    this.alarmsTable.map(row => {
                        if (row.Level === 3) this.cnt.alarms++
                    })

                    this.getFilteredDevices()
                })
            },
            getZones() {
                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Zone"
                }, this.form)

                this.$api.Main.getZones(request).then(response => {
                    this.loading = false
                    this.zonesDict = response.Items

                    this.total = response.Total
                    this.cnt.zones = response.Total

                    this.getDevices()
                }).catch (() => {
                    this.loading = false
                })
            },
            showDetails (id) {
                this.$router.push({ name: 'deviceDetails', params: { id: id } })
            }
        },
        mounted () {
            this.form = this.initCondition({model: this.form})
            if (typeof this.form.StatusID[0] === 'undefined' || isNaN(this.form.StatusID[0])) this.form.StatusID = ''
            this.getZones()
            this.getData()
        }
    }
</script>
